// useInteractions — visitor billing "dots" board state for a public silo.
// Fetches the board once on mount, lets /ask responses patch it live, and
// exposes an award() helper for client-reported tasks (home-screen, bookmark).
import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

export function useInteractions(slug, { enabled = true } = {}) {
  const [state, setState] = useState(null);

  const load = useCallback(async () => {
    if (!slug) return null;
    try {
      const r = await api.get(`/s/${slug}/interactions`);
      setState(r.data);
      return r.data;
    } catch {
      return null;
    }
  }, [slug]);

  useEffect(() => {
    if (enabled) load();
  }, [enabled, load]);

  // Patch from an /ask response (or a 402 wall payload) without a round-trip.
  const applyFromAsk = useCallback((snap) => {
    if (snap && typeof snap === "object") setState(snap);
  }, []);

  // Client-reported task completion (home_screen | bookmark). Capped server-side.
  const award = useCallback(async (task) => {
    if (!slug) return;
    try {
      const r = await api.post(`/s/${slug}/interactions/award`, { task });
      if (r.data?.interactions) setState(r.data.interactions);
    } catch {
      /* non-fatal */
    }
  }, [slug]);

  return { state, reload: load, applyFromAsk, award };
}
